import MembersCountIcon from "@/icons/presentation/MembersCountIcon.svg?react";
import styles from "./MembersCount.module.scss";
export const MembersCount = ({ count }: { count: number }) => {
    return (
        <div className={styles.membersCountWrapper}>
            <MembersCountIcon />
            <p>{count}</p>
        </div>
    );
};
